import { Button, Dialog, DialogContent, Slide, TextField } from '@mui/material'
import { useEffect, useState } from 'react'
import MuiDialogHeader from '../Shared/MuiDialogHeader';
import { IsEmail } from '../Shared/IsEmail';
import { useGateApi } from '../Api/useGateApi';
import { AddUserToTenantRequest, UsersGateApiClient } from '../Api/ApiServerHooks';
import { useTranslation } from 'react-i18next';

interface AddUserToTenantDialogProps {
    tenantId?: number;
    isOpen: boolean;
    onClose: (refresh: boolean, id?: number, exists?: boolean, email?: string, alreadyAdded?: boolean) => void;
}
export default function AddUserToTenantDialog(props: Readonly<AddUserToTenantDialogProps>) {
    const { isOpen, onClose, tenantId } = props;
    const { t } = useTranslation();
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [newEmail, setNewEmail] = useState('');
    const [openCreateError, setOpenCreateError] = useState(false);
    const { authorizedApi } = useGateApi(UsersGateApiClient);

    useEffect(() => {
        setNewEmail('');
        setButtonDisabled(false);
    }, []);

    function TransitionLeft(props: any) {
        return <Slide {...props} direction='left' />;
    }

    const handleClose = (event: any) => {
        setOpenCreateError(false);
    };

    return (
        <Dialog onClose={() => onClose(false)} open={isOpen}>
            <MuiDialogHeader showCloseText title={t('Users.AddUser')} onClose={() => onClose(false)} />
            <DialogContent>
                <div>
                    <div>
                        <TextField
                            sx={{ margin: '12px', marginLeft: '24px', width: '350px' }}
                            label={t('Users.Email')}
                            size='small'
                            variant='outlined'
                            value={newEmail}
                            onChange={(e) => { setNewEmail(e.target.value); }} />
                    </div>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
                        <Button variant='contained' sx={{ margin: 'auto' }} disabled={!newEmail || !IsEmail(newEmail) || buttonDisabled} onClick={() => {
                            setButtonDisabled(true);
                            authorizedApi?.addUserToTenant(new AddUserToTenantRequest({
                                email: newEmail,
                                sendMail: true,
                                tenantId: tenantId
                            })).then((e) => {
                                if (e.ok) {
                                    onClose(true, e.userId, e.ok, undefined, e.alreadyAdded);
                                }
                                else {
                                    onClose(false, undefined, false, newEmail)
                                }
                                setButtonDisabled(false);
                                setNewEmail('');
                            });
                        }}>{t('Users.Add')}</Button>
                    </div>

                    {/* <div className="create-form-popup">
                        <Snackbar
                            TransitionComponent={TransitionLeft}
                            open={openCreateError}
                            autoHideDuration={3000}
                            onClose={handleClose}
                            anchorOrigin={{ vertical: "top", horizontal: "right" }} >
                            <Alert onClose={handleClose} severity="warning">
                                <AlertTitle>{'Chyba zakládání'}</AlertTitle>
                                {'Tenant již existuje'}
                            </Alert>
                        </Snackbar>
                    </div> */}
                </div>
            </DialogContent>
        </Dialog>
    )
}
